import React from "react";

import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import Chip from "@material-ui/core/Chip";
import Skeleton from "@material-ui/lab/Skeleton";
import Rating from "@material-ui/lab/Rating";

import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  tableHead: {
    "& th": {
      fontWeight: 700,
      fontSize: "0.72rem",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.background.default,
      borderBottom: `2px solid ${theme.palette.divider}`,
      whiteSpace: "nowrap",
    },
  },
  tableRow: {
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  agentName: {
    fontWeight: 500,
    fontSize: "0.875rem",
  },
  chipOnline: {
    backgroundColor: "#e8f5e9",
    color: "#2e7d32",
    fontWeight: 600,
    fontSize: "0.72rem",
    height: 22,
    "& .MuiChip-icon": { color: "inherit" },
  },
  chipOffline: {
    backgroundColor: "#ffebee",
    color: "#c62828",
    fontWeight: 600,
    fontSize: "0.72rem",
    height: 22,
    "& .MuiChip-icon": { color: "inherit" },
  },
  sectionTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
  },
}));

export function RatingBox({ rating }) {
  const value = rating === null ? 0 : Math.trunc(rating);
  return (
    <Rating
      defaultValue={value}
      max={3}
      readOnly
      size="small"
      title="1 - Insatisfeito · 2 - Satisfeito · 3 - Muito Satisfeito"
    />
  );
}

function formatTime(minutes) {
  return moment().startOf("day").add(minutes, "minutes").format("HH[h] mm[m]");
}

export default function TableAttendantsStatus({ loading, attendants }) {
  const classes = useStyles();

  if (loading) return <Skeleton variant="rect" height={150} style={{ borderRadius: 8 }} />;

  return (
    <>
      <Typography variant="subtitle2" className={classes.sectionTitle}>
        Agentes ({attendants.length})
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small">
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell>Agente</TableCell>
              <TableCell align="center">Avaliação</TableCell>
              <TableCell align="center">T.M. Atendimento</TableCell>
              <TableCell align="center">Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {attendants.map((a, k) => (
              <TableRow key={k} className={classes.tableRow}>
                <TableCell>
                  <Typography className={classes.agentName}>{a.name}</Typography>
                </TableCell>
                <TableCell align="center">
                  <RatingBox rating={a.rating} />
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2">{formatTime(a.avgSupportTime)}</Typography>
                </TableCell>
                <TableCell align="center">
                  <Chip
                    size="small"
                    label={a.online ? "Online" : "Offline"}
                    className={a.online ? classes.chipOnline : classes.chipOffline}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
